import { render, staticRenderFns } from "./RegisterPet.vue?vue&type=template&id=284c6380&scoped=true&"
import script from "./RegisterPet.vue?vue&type=script&lang=js&"
export * from "./RegisterPet.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPet.vue?vue&type=style&index=0&id=284c6380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c6380",
  null
  
)

export default component.exports